import {
    List,
    Datagrid,
    TextField,
    ListProps,
    FunctionField,
    DateField,
    Pagination
} from 'react-admin'
import { Record, useTranslate } from 'ra-core'

import datagridStyles from '../../layout/styles/datagridStyles'
import SchoolYearListFilter from './SchoolYearListFilters'
import DatagridPublishedColumnContent from '../../components/common/DatagridPublishedColumnContent'
import BulkActionButtons from 'components/common/BulkActionButtons'
import { CustomDatagridBody } from 'components/common/CustomDatagridBody'
import { DEFAULT_PER_PAGE, ROWS_PER_PAGE } from '../../globals'

const SchoolYearList = (props: ListProps) => {
    const datagridClasses = datagridStyles()
    const translate = useTranslate()

    return (
        <List
            {...props}
            sort={{ field: 'name', order: 'DESC' }}
            perPage={DEFAULT_PER_PAGE}
            bulkActionButtons={<BulkActionButtons />}
            filters={SchoolYearListFilter}
            pagination={<Pagination rowsPerPageOptions={ROWS_PER_PAGE} />}
        >
            <Datagrid body={<CustomDatagridBody />} classes={datagridClasses} rowClick="edit">
                <TextField source="name" label={translate('manager.resources.schoolYear.name')} />
                <FunctionField
                    source="active"
                    label={translate('manager.resources.general.status')}
                    render={(record?: Record | undefined) => (
                        <DatagridPublishedColumnContent record={record} />
                    )}
                />
                <DateField
                    label={translate('manager.resources.general.last_updated')}
                    source="updated_at"
                    showTime
                />
            </Datagrid>
        </List>
    )
}
export default SchoolYearList
